export enum ClassroomSourceType {
	// Synced sources
	Azure = "azure",
	ClassLink = "classlink",
	Clever = "clever",
	Google = "google",
	LDAP = "ldap",
	OneRoster = "oneroster",
	Wonde = "wonde",
	PowerSchool = "powerschool",

	// Local and Combined classrooms are created in School Manager or Classwize and are not synced from any external source.
	Local = "local",
	CSV = "csv",
	Combined = "combined",
}

/**
 * @deprecated - Use ClassroomSourceType enum once migrated to TypeScript
 * The ClassroomSourceType enum exported as a const object for legacy JavaScript code. When the TypeScript is transpiled to JavaScript, these are populated as the enum values.
 */
export const CLASSROOM_SOURCE_TYPES = {
	// Synced sources
	GOOGLE: ClassroomSourceType.Google,
	CLEVER: ClassroomSourceType.Clever,
	ONEROSTER: ClassroomSourceType.OneRoster,
	CLASSLINK: ClassroomSourceType.ClassLink,
	WONDE: ClassroomSourceType.Wonde,
	POWERSCHOOL: ClassroomSourceType.PowerSchool,

	// Unsynced sources
	LOCAL: ClassroomSourceType.Local,
	CSV: ClassroomSourceType.CSV,
	COMBINED: ClassroomSourceType.Combined,
};

export enum ClassroomType {
	Classroom = "classroom",
	Group = "group",
}

/**
 * @deprecated - Use ClassroomType enum once migrated to TypeScript
 * The ClassroomType enum exported as a const object for legacy JavaScript code. When the TypeScript is transpiled to JavaScript, these are populated as the enum values.
 */
export const CLASSROOM_TYPES = {
	CLASSROOM: ClassroomType.Classroom,
	GROUP: ClassroomType.Group,
};
